
var stringUtil = require('../../../utils/string/stringUtil.js');
var constants = require('../../../utils/domain/constants.js');
var dateUtil = require('../../../utils/dateUtil/dateUtil.js');
var stateManager = require('../../../utils/state/stateManager');
const localizationUtils = require('../../../utils/domain/localizationUtils');

const defaultCategoryBackColor = "#FFFFFF";
const defaultCategoryForeColor = "#808080";

const defaultCategorySelectedBackColor = "#606060";
const defaultCategorySelectedForeColor = "#FFFFFF";

const defaultCategoryDisabledBackColor = "#E8E8E8";
const defaultCategoryDisabledForeColor = "#909090";

const negateConstraints = -1;
const applyConstraints = 0;
const pledgeConstraints = 1;

module.exports.calculateEffectiveMenu = function (priceBandId, menu, propertyId, venueCode, dispatchType)
{
    var effectiveMenu = {};

    effectiveMenu.franchisorId = menu.franchisorId;
    effectiveMenu.id = menu.id;
    effectiveMenu.name = menu.name;
    effectiveMenu.notes = menu.notes;

    effectiveMenu.categories = [];

    menu.categories.forEach(category =>
    {
        var effectiveCategory = getEffectiveMenuCategory(priceBandId, menu, category, propertyId, venueCode, dispatchType);
        if (effectiveCategory != null)
        {
            setCategoryOnItems(effectiveCategory);
            effectiveMenu.categories.push(effectiveCategory);
        }
    });

    return effectiveMenu;
}

function setCategoryOnItems(effectiveCategory)
{
    effectiveCategory.items.forEach(categoryItem => 
    {
        categoryItem.category = effectiveCategory.caption;
        categoryItem.modifiers.forEach(modifier => 
        {
            setCategoryOnModifierItems(modifier);
        })
    })

    function setCategoryOnModifierItems(modifier)
    {
        modifier.items.forEach(modifierItem =>
        {
            modifierItem.category = effectiveCategory.caption;
            modifierItem.modifiers.forEach(subModifier => 
            {
                setCategoryOnModifierItems(subModifier);
            })
        });
    }
}



function getEffectiveMenuCategory (priceBandId, menu, category, propertyId, venueCode, dispatchType)
{
    var isEnabledOrDisabledInOverride = getEnableFlagViaOverrides(category.overrides, negateConstraints, propertyId, venueCode, dispatchType);
    if (isEnabledOrDisabledInOverride == -1)        
        return null;

    isEnabledOrDisabledInOverride = getEnableFlagViaOverrides(category.overrides, pledgeConstraints, propertyId, venueCode, dispatchType); 
  
    if (!category.enabled && isEnabledOrDisabledInOverride <= 0)
        return null;                                


    isEnabledOrDisabledInOverride = getEnableFlagViaOverrides(category.overrides, applyConstraints, propertyId, venueCode, dispatchType); 
  
    var effectiveCategory = {};
    effectiveCategory.caption = category.caption;
    effectiveCategory.items = [];
    effectiveCategory.notes = category.notes;
    
    effectiveCategory.enabled =   (category.enabled && isEnabledOrDisabledInOverride == 0) ||  isEnabledOrDisabledInOverride == 1;
    if (!effectiveCategory.enabled)
    {
        effectiveCategory.backgroundColor = defaultCategoryDisabledBackColor;
        effectiveCategory.foregroundColor = defaultCategoryDisabledForeColor;
        effectiveCategory.selectedBackgroundColor = defaultCategoryDisabledBackColor;
        effectiveCategory.selectedForegroundColor = defaultCategoryDisabledForeColor;
        return effectiveCategory;
    }

    effectiveCategory.backgroundColor = defaultCategoryBackColor;
    effectiveCategory.foregroundColor = defaultCategoryForeColor;
    effectiveCategory.selectedBackgroundColor = defaultCategorySelectedBackColor;
    effectiveCategory.selectedForegroundColor = defaultCategorySelectedForeColor;
    if (!stringUtil.isStringNullOrEmpty(category.backgroundColor)) effectiveCategory.backgroundColor = category.backgroundColor;
    if (!stringUtil.isStringNullOrEmpty(category.foregroundColor)) effectiveCategory.foregroundColor = category.foregroundColor;
    if (!stringUtil.isStringNullOrEmpty(category.selectedBackgroundColor)) effectiveCategory.selectedBackgroundColor = category.selectedBackgroundColor;
    if (!stringUtil.isStringNullOrEmpty(category.selectedForegroundColor)) effectiveCategory.selectedForegroundColor = category.selectedForegroundColor;
    

    category.items.forEach(item =>
    {
        var effectiveItem = getEffectiveCategoryItem(priceBandId, menu, item, propertyId, venueCode, dispatchType);
        if (effectiveItem != null)  
            effectiveCategory.items.push(effectiveItem); 
    });


    return effectiveCategory;
}

function getEffectiveCategoryItem(priceBandId, menu, item, propertyId, venueCode, dispatchType)
{

    var isEnabledOrDisabledInOverride = getEnableFlagViaOverrides(item.overrides, negateConstraints, propertyId, venueCode, dispatchType);
    if (isEnabledOrDisabledInOverride == -1)        
        return null;

    isEnabledOrDisabledInOverride = getEnableFlagViaOverrides(item.overrides, pledgeConstraints, propertyId, venueCode, dispatchType); 
  
    if (!item.enabled && isEnabledOrDisabledInOverride <= 0)
        return null;                                


    isEnabledOrDisabledInOverride = getEnableFlagViaOverrides(item.overrides, applyConstraints, propertyId, venueCode, dispatchType); 
  
    var effectiveItem = {};
    effectiveItem.id = item.id;
    effectiveItem.productId = item.productId;
    effectiveItem.caption = item.caption;
    effectiveItem.imageUrl = item.imageUrl;
    effectiveItem.notes = item.notes;
    if (!stringUtil.isStringNullOrEmpty(item.backgroundColor)) effectiveItem.backgroundColor = item.backgroundColor;
    if (!stringUtil.isStringNullOrEmpty(item.foregroundColor)) effectiveItem.foregroundColor = item.foregroundColor;
    effectiveItem.modifiers = [];
    effectiveItem.paramsJson = item.paramsJson;

    effectiveItem.enabled = (item.enabled && isEnabledOrDisabledInOverride == 0) ||  isEnabledOrDisabledInOverride == 1;
    updatePrice(priceBandId, item, effectiveItem, dispatchType);
    updateUpSellingPoints(priceBandId, item, effectiveItem, dispatchType);

    if (effectiveItem.price == null || effectiveItem.tax == null)
        effectiveItem.enabled = false;

    if (!effectiveItem.enabled)
        return effectiveItem;
    

    item.modifierMembers.forEach (modifierMember =>
    {
        var effectiveModifier = getEffectiveModifierMembership(priceBandId, menu, modifierMember, propertyId, venueCode, dispatchType);
        if (effectiveModifier != null)
            effectiveItem.modifiers.push(effectiveModifier);
    });


    return effectiveItem;
}

function getEffectiveModifierMembership(priceBandId, menu, modifierMember, propertyId, venueCode, dispatchType)
{
    var modifier = menu.modifiers.find (m => m.id == modifierMember.modifierId);

    if (modifier == null)
        return null;

    var isEnabledOrDisabledInOverride = getEnableFlagViaOverrides(modifier.overrides, applyConstraints, propertyId, venueCode, dispatchType); 

    /*
    if (isEnabledOrDisabledInOverride == -1 ||  (isEnabledOrDisabledInOverride == 0 && !modifier.enabled))
        return null;*/

    if (isEnabledOrDisabledInOverride == -1)        //Once enabled flag is available, we should uncomment and delete this line.
        return null;

    var effectiveModifier = {};
    effectiveModifier.caption = modifier.caption;
    effectiveModifier.min = modifier.min;
    effectiveModifier.max = modifier.max;
    effectiveModifier.canSameItemBeSelectedMultipleTimes = modifier.canSameItemBeSelectedMultipleTimes;
    effectiveModifier.hiddenInOrderFlow = modifier.hiddenInOrderFlow;
    effectiveModifier.membershipId = modifierMember.id;
    effectiveModifier.id = modifier.id;
    effectiveModifier.items = [];

    if (!stringUtil.isStringNullOrEmpty(modifierMember.caption))
        effectiveModifier.caption = modifierMember.caption;

    if (!stringUtil.isStringNullOrEmpty(modifierMember.min) && !stringUtil.isStringNullOrEmpty(modifierMember.max))
    {
        effectiveModifier.min = modifierMember.min;
        effectiveModifier.max = modifierMember.max;
    }

    modifier.items.forEach(modifierItem =>
        {
            var effectiveModifierItem = getEffectiveModifierItem(priceBandId, menu, modifierItem, propertyId, venueCode, dispatchType);
            if (effectiveModifierItem != null)
                effectiveModifier.items.push(effectiveModifierItem);
        })

    
    if (effectiveModifier.items.length <= 0)
        return null;

    return effectiveModifier;
}

function getEffectiveModifierItem(priceBandId, menu, modifierItem, propertyId, venueCode, dispatchType)
{
    var isEnabledOrDisabledInOverride = getEnableFlagViaOverrides(modifierItem.overrides, applyConstraints, propertyId, venueCode, dispatchType); 
    if (isEnabledOrDisabledInOverride == -1 ||  (isEnabledOrDisabledInOverride == 0 && !modifierItem.enabled))
        return null;
  
    var effectiveModifierItem = {};
    effectiveModifierItem.id = modifierItem.id;
    effectiveModifierItem.productId = modifierItem.productId;
    effectiveModifierItem.caption = modifierItem.caption;
    effectiveModifierItem.imageUrl = modifierItem.imageUrl;
    effectiveModifierItem.autoSelectedQuantity = modifierItem.autoSelectedQuantity;
    effectiveModifierItem.modifiers = [];
    effectiveModifierItem.notes = modifierItem.notes;
    effectiveModifierItem.backgroundColor = null;
    effectiveModifierItem.foregroundColor = null;
    effectiveModifierItem.paramsJson = modifierItem.paramsJson;

    if (!stringUtil.isStringNullOrEmpty(modifierItem.backgroundColor))
        effectiveModifierItem.backgroundColor = modifierItem.backgroundColor;

    if (!stringUtil.isStringNullOrEmpty(modifierItem.foregroundColor))
        effectiveModifierItem.foregroundColor = modifierItem.foregroundColor;


    updatePrice(priceBandId, modifierItem, effectiveModifierItem, dispatchType);
    updateUpSellingPoints(priceBandId, modifierItem, effectiveModifierItem, dispatchType);
    if (effectiveModifierItem.price == null || effectiveModifierItem.tax == null)
        return null;

    modifierItem.modifierMembers.forEach (modifierMember =>
        {
            var effectiveModifier = getEffectiveModifierMembership(priceBandId, menu, modifierMember, propertyId, venueCode, dispatchType);
            if (effectiveModifier != null)
                effectiveModifierItem.modifiers.push(effectiveModifier);
        });

    return effectiveModifierItem;
}

function updatePrice (priceBandId, item, effectivePrice, dispatchType)
{
    effectivePrice.price = null;
    effectivePrice.taxablePrice = null;
    effectivePrice.tax = null;
    
    if (priceBandId == null)
        return;
    
    var pricingProfile =  item.pricingProfiles.find (p => p.priceBandId == priceBandId);
    if (pricingProfile == null)
        return;
    
    if (dispatchType == constants.DispatchTypeDineIn)
    {
        
        if (stringUtil.isStringNullOrEmpty(pricingProfile.dineInPrice))
            return;
        
        effectivePrice.price = pricingProfile.dineInPrice * 1;
        effectivePrice.taxablePrice = effectivePrice.price;
        if(!stringUtil.isStringNullOrEmpty(pricingProfile.dineInTaxablePrice))
            effectivePrice.taxablePrice = pricingProfile.dineInTaxablePrice * 1;
        updateTax(effectivePrice, pricingProfile.dineInTaxable, pricingProfile.dineInTax);
    }

    if (dispatchType == constants.DispatchTypeTakeAway)
    {
        if (stringUtil.isStringNullOrEmpty(pricingProfile.takeawayPrice))
            return;

        effectivePrice.price = pricingProfile.takeawayPrice * 1;
        effectivePrice.taxablePrice = effectivePrice.price;
        if(!stringUtil.isStringNullOrEmpty(pricingProfile.takeawayTaxablePrice))
            effectivePrice.taxablePrice = pricingProfile.takeawayTaxablePrice * 1;
        updateTax(effectivePrice, pricingProfile.takeawayTaxable, pricingProfile.takeawayTax);
    }

    if (dispatchType == constants.DispatchTypeCollection)
    {
        if (stringUtil.isStringNullOrEmpty(pricingProfile.collectionPrice))
            return;

        effectivePrice.price = pricingProfile.collectionPrice * 1;
        effectivePrice.taxablePrice = effectivePrice.price;
        if(!stringUtil.isStringNullOrEmpty(pricingProfile.collectionTaxablePrice))
            effectivePrice.taxablePrice = pricingProfile.collectionTaxablePrice * 1;
        updateTax(effectivePrice, pricingProfile.collectionTaxable, pricingProfile.collectionTax);
    }

    if (dispatchType == constants.DispatchTypeDelivery)
    {
        if (stringUtil.isStringNullOrEmpty(pricingProfile.deliveryPrice))
            return;

        effectivePrice.price = pricingProfile.deliveryPrice * 1;
        effectivePrice.taxablePrice = effectivePrice.price;
        if(!stringUtil.isStringNullOrEmpty(pricingProfile.deliveryTaxablePrice))
            effectivePrice.taxablePrice = pricingProfile.deliveryTaxablePrice * 1;
        updateTax(effectivePrice, pricingProfile.deliveryTaxable, pricingProfile.deliveryTax);
    }
}

function updateTax(effectivePrice, taxable, tax)
{
    if(!taxable || !localizationUtils.isVatApplicable())
    {
        effectivePrice.tax = 0.0;
    }
    else
    {
        tax = Number(tax) || 0.0;
        
        if(tax > 0.0)
        {
            effectivePrice.tax = tax / 100;
        }
        else
        {
            effectivePrice.tax = getMenuVatRate() / 100;
        }
    }
}

function updateUpSellingPoints (priceBandId, item, effectivePrice, dispatchType)
{
    effectivePrice.upsellingPoints = 0.0;
    
    if (priceBandId == null)
        return;

    var pricingProfile =  item.pricingProfiles.find (p => p.priceBandId == priceBandId);
    if (pricingProfile == null)
        return;

    if (dispatchType == constants.DispatchTypeDineIn)
    {
        
        if (stringUtil.isStringNullOrEmpty(pricingProfile.dineInUpsellingPoints))
            return;
        
        effectivePrice.upsellingPoints = pricingProfile.dineInUpsellingPoints * 1;
    }

    if (dispatchType == constants.DispatchTypeTakeAway)
    {
        
        if (stringUtil.isStringNullOrEmpty(pricingProfile.takeawayUpsellingPoints))
            return;
        
        effectivePrice.upsellingPoints = pricingProfile.takeawayUpsellingPoints * 1;
    }

    if (dispatchType == constants.DispatchTypeCollection)
    {
        
        if (stringUtil.isStringNullOrEmpty(pricingProfile.collectionUpsellingPoints))
            return;
        
        effectivePrice.upsellingPoints = pricingProfile.collectionUpsellingPoints * 1;
    }

    if (dispatchType == constants.DispatchTypeDelivery)
    {
        
        if (stringUtil.isStringNullOrEmpty(pricingProfile.deliveryUpsellingPoints))
            return;
        
        effectivePrice.upsellingPoints = pricingProfile.deliveryUpsellingPoints * 1;
    }
}

function getMenuVatRate()
{
    const franchisor = stateManager.getStore().getState().orgData.franchisor;

    return Number(franchisor.operatingConfiguration.menuVatRate) || localizationUtils.getVatPercentage() || 0.0;
}

function getEnableFlagViaOverrides(overrides, constraintsApplicationRule, propertyId, venueCode, dispatchType)          //-1: disabled, 0: no override, 1: enabled
{
    var result = 0;

    if (overrides == null || overrides.length <= 0)
        return result;

    for (var index = 0; index < overrides.length; index++)
    {
        var override = overrides[index];
        if (stringUtil.isStringNullOrEmpty(override.paramsJson))
            continue;
            
        override = JSON.parse(override.paramsJson);
        
        if (constraintsApplicationRule == negateConstraints)       //i.e. negate constraints
        {
            if (isDayConstraintAvailable(override) || isTimeConstraintAvailable(override))
                continue;
        }

        if (!stringUtil.isStringNullOrEmpty(override.propertyId) && !stringUtil.areStringSame(override.propertyId, propertyId))
            continue;

        if (!stringUtil.isStringNullOrEmpty(override.dispatchType) && !stringUtil.areStringSame(override.dispatchType, dispatchType))
            continue;

        if (!stringUtil.isStringNullOrEmpty(override.venueCode) && !stringUtil.areStringSame(override.venueCode, venueCode))
            continue;   

        if (constraintsApplicationRule == applyConstraints)
        {
            if (!isDayConstraintsMet(override) || !IsTimeConstraintsMet(override))
                continue;
        }
     
        if (!override.enabled)
            result = -1;
        else
        {
            if (result != -1)
                result = 1;
        }
    }
    
    return result;
}

function isDayConstraintsMet(override) //-1: disabled, 0: no override, 1: enabled
{
    var today = dateUtil.getToday();

    if (!isDayConstraintAvailable(override))
        return true;

    if (dateUtil.getDay(today) == 0 && !stringUtil.isStringNullOrEmpty(override.sundayEnabled) && override.sundayEnabled)
        return true;

    if (dateUtil.getDay(today) == 1 && !stringUtil.isStringNullOrEmpty(override.mondayEnabled) && override.mondayEnabled)
        return true;

    if (dateUtil.getDay(today) == 2 && !stringUtil.isStringNullOrEmpty(override.tuesdayEnabled) && override.tuesdayEnabled)
        return true;

    if (dateUtil.getDay(today) == 3 && !stringUtil.isStringNullOrEmpty(override.wednesdayEnabled) && override.wednesdayEnabled)
        return true;

    if (dateUtil.getDay(today) == 4 && !stringUtil.isStringNullOrEmpty(override.thursdayEnabled) && override.thursdayEnabled)
        return true;

    if (dateUtil.getDay(today) == 5 && !stringUtil.isStringNullOrEmpty(override.fridayEnabled) && override.fridayEnabled)
        return true;

    if (dateUtil.getDay(today) == 6 && !stringUtil.isStringNullOrEmpty(override.saturdayEnabled) && override.saturdayEnabled)
        return true;

    return false;
}

function IsTimeConstraintsMet(override) //-1: disabled, 0: no override, 1: enabled
{

    if (!isTimeConstraintAvailable(override))
        return true;

    const currentLocalDateTime = dateUtil.convertToLocalStandard(dateUtil.getNow());

    const fromTime = dateUtil.setDateComponent(override.fromTime, dateUtil.getDate(currentLocalDateTime), dateUtil.getMonth(currentLocalDateTime), dateUtil.getYear(currentLocalDateTime));
    const toTime = dateUtil.setDateComponent(override.toTime, dateUtil.getDate(currentLocalDateTime), dateUtil.getMonth(currentLocalDateTime), dateUtil.getYear(currentLocalDateTime));

    return dateUtil.isSameOrAfter(currentLocalDateTime, fromTime) && dateUtil.isSameOrBefore(currentLocalDateTime, toTime);
}

function isDayConstraintAvailable(override)
{
    return  (!stringUtil.isStringNullOrEmpty(override.sundayEnabled) && override.sundayEnabled) || 
            (!stringUtil.isStringNullOrEmpty(override.mondayEnabled) && override.mondayEnabled) || 
            (!stringUtil.isStringNullOrEmpty(override.tuesdayEnabled) && override.tuesdayEnabled) || 
            (!stringUtil.isStringNullOrEmpty(override.wednesdayEnabled) && override.wednesdayEnabled) || 
            (!stringUtil.isStringNullOrEmpty(override.thursdayEnabled) && override.thursdayEnabled) || 
            (!stringUtil.isStringNullOrEmpty(override.fridayEnabled) && override.fridayEnabled) || 
            (!stringUtil.isStringNullOrEmpty(override.saturdayEnabled) && override.saturdayEnabled);
}

function isTimeConstraintAvailable(override)
{
    return !stringUtil.isStringNullOrEmpty(override.fromTime) && !stringUtil.isStringNullOrEmpty(override.toTime);
}
